export default {
  root: {
    "&$error": {
      whiteSpace: 'pre-wrap'
    },
  }
};